import liff, { Liff } from "@line/liff";

let liffReadyPromise: Promise<Liff> | null = null;

export const liffRedirectUrl = import.meta.env.VITE_LIFF_REDIRECT_URL;
const LIFF_ID_STORAGE_KEY = "liffId";
const LIFF_ID_FROM_ENV = import.meta.env.VITE_LIFF_ID as string | undefined;

const getLiffIdFromUrlString = (url: string): string | null => {
  try {
    const parsedUrl = new URL(url, globalThis.location.origin);
    return parsedUrl.searchParams.get("liffId");
  } catch {
    return null;
  }
};

const getLiffIdFromLiffState = (): string | null => {
  const liffState = new URLSearchParams(globalThis.location.search).get(
    "liff.state",
  );

  if (!liffState) {
    return null;
  }

  return getLiffIdFromUrlString(decodeURIComponent(liffState));
};

const resolveLiffId = async (): Promise<string> => {
  const liffId = getLiffIdFromLiffState();
  if (liffId) {
    localStorage.setItem(LIFF_ID_STORAGE_KEY, liffId);
    return liffId;
  }

  const storedLiffId = localStorage.getItem(LIFF_ID_STORAGE_KEY);
  if (storedLiffId) {
    return storedLiffId;
  }

  // Fallback to env variable when liff.state and localStorage are both unavailable
  if (LIFF_ID_FROM_ENV) {
    return LIFF_ID_FROM_ENV;
  }

  return '';
};

export const initLiff = async (): Promise<Liff> => {
  liffReadyPromise ??= resolveLiffId()
    .then((liffId) => liff.init({
      liffId,
      withLoginOnExternalBrowser: true,
    }))
    .then(() => liff)
    .catch((error) => {
      // Never cache a rejected init: a transient failure (network blip,
      // missing liff.state on this open) would otherwise fail every later
      // call until the member kills the webview.
      liffReadyPromise = null;
      throw error;
    });
  return liffReadyPromise;
};
